import Moment from 'moment-timezone';
import { BasicModel } from '@/models/BasicModel';

/**
 * Cause object
 */
export class Cause extends BasicModel {
  // Cause-specific properties
  id = 0;

  type = 0;

  text = '';

  problem = 0;

  cause = 0;

  ishikawaBranch = 0;

  hideInSheet = 0;

  isVerified = 0;

  isReal = 0;

  created = null;

  updated = null;

  // Foreign keys
  problem = 0;

  // Built properties
  files = [];

  wCauses = [];

  constructor(props, autoFill = true) {
    super(props);
    this.setProps(props);
    if (autoFill) {
      this.created = this.created === null ? Moment().format('YYYY-MM-DD HH:mm:ss') : this.created;
    }

    if (this.wCauses) {
      this.wCauses = this.wCauses.map(subcause => new Cause(subcause));
    }
  }

  setProps(props) {
    BasicModel.updateObjectProps(props, this);
  }

  /**
   * Return the params that should be used in the PUT /causes query to update a cause.
   * @return {Object}
   */
  get updateQueryParams() {
    const noTransformParams = [
      'type',
      'text',
      'cause',
      'ishikawaBranch',
      'hideInSheet',
      'isVerified',
      'isReal',
      'files',
      'problem',
    ];
    const params = noTransformParams.reduce((all, param) => ({ ...all, [param]: this[param] }), {});
    params.problemId = this.problem;
    return params;
  }
}

export default {
  Cause,
};
